import {
  CollectionReference,
  doc,
  DocumentReference,
} from '@principle-theorem/shared';
import { TranslationMapHandler } from '.';

export class PreloadTranslationMap {
  static async preload<T extends object>(
    translationMap: TranslationMapHandler,
    resourceType: string,
    collectionReference: CollectionReference<T>,
    sourceIdentifier: string
  ): Promise<DocumentReference<T>> {
    const existingMapping = await translationMap.getDestination<T>(
      sourceIdentifier,
      resourceType
    );

    if (existingMapping) {
      return existingMapping;
    }

    const newDocRef = doc(collectionReference);

    await translationMap.upsert({
      sourceIdentifier,
      destinationIdentifier: newDocRef,
      resourceType: resourceType,
    });

    return newDocRef;
  }
}
